
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { getInvestorAuth, getInvestorAgency } from 'api/investor'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
PopupRadio
},
data () {
return {
localValidity: '存在有效期',
loading: true,
type: 0,
data: {
transactorName: '',
transactorSex: '',
transactorAge: '',
transactorCertigicateType: '身份证',
transactorCertigicateNo: '',
transactorCertificateValidity: '',
transactorPosition: '',
transactorLandline: '',
transactorMobile: '',
transactorEmail: '',
transactorOfficeZip: '',
transactorOfficeAddress: '',
transactorProductRelation: ''
},
isIdCard: function (value) {
return {
valid: /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])\d{3}(\d|[xX])$/.test(value),
msg: '身份证号码格式不正确'
}
},
isPhone: function (value) {
return {
valid: /\d{1,20}/.test(value),
msg: '号码格式不正确'
}
},
valid: {
transactorName: false,
transactorAge: false,
transactorCertigicateType: false,
transactorCertigicateNo: false,
transactorCertificateValidity: false,
transactorPosition: false,
transactorLandline: false,
transactorMobile: false,
transactorEmail: false,
transactorOfficeZip: false,
transactorOfficeAddress: false,
transactorProductRelation: false
}
}
},
watch: {
localValidity: function (val, oldVal) {
if (val === '永久有效') {
this.data.transactorCertificateValidity = val
} else {
this.data.transactorCertificateValidity = ''
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
this.$bridge.registerHandler('getUpdate', this.$_product_update)
this.$_product_init()
},
methods: {
$_product_update () {
this.type = 1
},
$_product_init () {
let _this = this
setTimeout(() => {
_this.type = parseInt(this.$route.query.type)
if (_this.$route.query.oldInfo) {
let res = JSON.parse(this.$route.query.oldInfo)
_this.data = {
transactorName: res.transactorName,
transactorSex: res.transactorSex,
transactorAge: res.transactorAge,
transactorCertigicateType: res.transactorCertigicateType,
transactorCertigicateNo: res.transactorCertigicateNo,
transactorCertificateValidity: res.transactorCertificateValidity,
transactorPosition: res.transactorPosition,
transactorLandline: res.transactorLandline,
transactorMobile: res.transactorMobile,
transactorEmail: res.transactorEmail,
transactorOfficeZip: res.transactorOfficeZip,
transactorOfficeAddress: res.transactorOfficeAddress,
transactorProductRelation: res.transactorProductRelation
}
} else {

_this.$bridge.callHandler('getUserInfo', {msg: '获取产品ID和AU'}, (res) => {
let data = JSON.parse(res)
getInvestorAgency({userId: data.extendC, invenstemUserId: data.extendD, globalVersion: data.globalVersion}, data.au).then((response) => {
if (response.code === 0) {
let resInfo = response.data.bean
_this.data = {
transactorName: resInfo.managersName,
transactorSex: resInfo.managersSex,
transactorAge: resInfo.managersAge,
transactorCertigicateType: resInfo.managersDocumentsType,
transactorCertigicateNo: resInfo.managersIdCardNo,
transactorCertificateValidity: resInfo.managersDocumentsValidity,
transactorPosition: resInfo.managersPosition,
transactorLandline: resInfo.managersLanline,
transactorMobile: resInfo.managersMobile,
transactorEmail: resInfo.managersEmail,
transactorOfficeZip: resInfo.managersZip,
transactorOfficeAddress: resInfo.managersAddress,
transactorProductRelation: resInfo.relationshipWithOrg
}
}
})
})
}
_this.loading = false
_this.$vux.loading.hide()
}, 500)
},
idcardChange (val) {
if (this.type === 1) {
if (val && val.length === 18) {
const year = Number(val.substring(6, 10))
const month = Number(val.substring(10, 12))
const day = Number(val.substring(12, 14))
const Year = new Date().getFullYear()
const Month = new Date().getMonth() + 1
const Day = new Date().getDate()
const Sex = Number(val.substring(16, 17))
const birstday = Number(`${year}${month}${day}`)
const Now = Number(`${Year}${Month}${Day}`)
this.data.transactorAge = birstday - Now > -1 ? Year - year : Year - year - 1
this.data.transactorSex = Sex % 2 === 0 ? '女' : '男'
} else {
this.data.transactorAge = null
this.data.transactorSex = null
}
}
},
$_product_auth () {
if (this.type === 0) {
this.$_product_next()
} else {
for (var item in this.valid) {
console.log(this.data[item])
if (this.data[item] === '') {
this.$refs[item].valid = false
}
if (!this.$refs[item].valid) {
this.$vux.toast.show({
type: 'warn',
text: '参数为空或输入不合规范'
})
return
}
}
this.$_handle_auth()
}
},
$_handle_auth () {
this.$vux.loading.show({text: '加载中'})
getInvestorAuth({userId: 0, name: this.data.transactorName, idcard: this.data.transactorCertigicateNo}, this.$route.query.au).then((res) => {
this.$vux.loading.hide()
if (res.code === 0) {
this.$_product_next()
} else {
this.$vux.alert.show({
title: '提示',
content: res.msg
})
}
})
},
$_product_next () {
this.$route.query.type = this.type
this.$router.push({path: '/investor/product/three', query: Object.assign(this.data, this.$route.query)})
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Product/Two.vue